export var version = "3.12.9";
//# sourceMappingURL=version.js.map